<template>
  <div class="styj">

    <Head v-bind:headTxt="headTxt"></Head>

    <YangBen v-bind:YangBenBox="YangBenBox"></YangBen>

    <ShiJi v-bind:shiJiBox="shiJiBox"></ShiJi>

    <RightBox v-bind:rightBox="rightBox"></RightBox>

    <div class="map_box">
      <Map v-bind:mapBut="mapBut"></Map>
    </div>

    <div class="l_box">
      <div class="bgc l_box_1">
        <div class="l_box_1_1">
          <div class="box">
            <div class="title box_title">教育</div>
            <div class="box_txt">
              <div class="box_txt_1">
                <ul>
                  <li>幼儿园：{{zlyxList.d_Education_kindergarten}}</li>
                  <li>小学：{{zlyxList.d_Education_primary}}</li>
                  <li>中学：{{zlyxList.d_Education_middle}}</li>
                </ul>
              </div>
              <div class="box_txt_2">
                <span class="txtc">{{(zlyxList.d_Education_kindergarten) + (zlyxList.d_Education_primary) + (zlyxList.d_Education_middle)}}</span>
                <p>总数</p>
              </div>
            </div>
          </div>
          <div class="img">
            <div v-show="jiaoyuList.length > 0">
              <el-carousel height="100%"
                           indicator-position="none">
                <el-carousel-item v-for="(item,index) in jiaoyuList"
                                  :key="index">
                  <el-image style="width:100%; height:100%"
                            :src="item"
                            fit="cover"></el-image>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div v-show="jiaoyuList.length == 0">
              <span class="noTxt"
                    style="line-height:20vh;margin-left:30%">暂无调研图片</span>
            </div>
          </div>
        </div>
        <div class="l_box_1_2">
          <div class="box_1_2_txt">教育从业人员：{{zlyxList.d_Education_teacher}}</div>
          <div class="box_1_2_txt">在读大学生：{{zlyxList.d_Education_college}}</div>
        </div>
        <div class="l_box_1_2">
          <div class="box_1_2_txt">高中以上学历村民：{{zlyxList.d_Education_village}}</div>
        </div>
      </div>
      <div class="bgc l_box_2">
        <div class="title">医疗卫生</div>
        <div class="box">
          <div class="img_box">
            <div class="txt">常驻医疗人员：{{zlyxList.d_Medical_quantity}}</div>
            <div class="img">
              <div v-show="yiliaoList.length > 0">
                <el-carousel height="100%"
                             indicator-position="none">
                  <el-carousel-item v-for="(item,index) in yiliaoList"
                                    :key="index">
                    <el-image style="width:100%; height:100%"
                              :src="item"
                              fit="cover"></el-image>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div v-show="yiliaoList.length == 0">
                <span class="noTxt"
                      style="line-height:20vh;margin-left:30%">暂无调研图片</span>
              </div>
            </div>
          </div>
          <div class="txt_box">
            <div class="txt_box_1">
              <div class="box_1_t">
                <span class="txtc">{{(this.zlyxList.d_Medical_without) + (this.zlyxList.d_Medical_three) + (this.zlyxList.d_Medical_five)}}</span>个
                <p>总计</p>
              </div>
              <div class="chart1"
                   id="l_chart_weishenshi"></div>
            </div>
            <div class="txt_box_1"
                 style="margin-top: 1vh;">
              <div class="box_1_t">
                <span class="txtc">{{(this.zlyxList.d_Medical_wchave) + (this.zlyxList.d_Medical_wcwithout)}}</span>个
                <p>总计</p>
              </div>
              <div class="chart1"
                   id="l_chart_gongong"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import YangBen from '@/components/YangBen.vue'
import RightBox from '@/components/RightBox.vue'
import ShiJi from '@/components/ShiJi.vue'
import Map from '@/components/Map.vue'
import bus from '../utils/bus.js'


export default {
  components: {
    Head,
    YangBen,
    RightBox,
    ShiJi,
    Map
  },
  data () {
    return {
      city_id: 0,
      zlyxList: {},
      YangBenBox: {
        xian: '123',
        xiang: '12',
        cun: '1'
      },
      shiJiBox: {
        shiJiTitle: '治理有效大事记',
        diDian: '湖南省',
        shiJiList: [
          '勾蓝瑶寨农村环境整治整体推进综合治理项目，自2018年6月开工建设以来，共投资60余万元，对全村进行集中整治。建设了农村饮用水项目、生活污水治理项目、生活垃圾收集系统、农村改厕改水和农村“五清五化”治理等。',
          '2022年8月，青年水库，水域面积750多亩，总库容600余万立方米，主要用于农业灌溉、城市生态补水、防洪排涝、景观用水等，提升青年水库水质，加强周边生态环境保护尤为重要。',
        ]
      },
      rightBox: {
        boxTitle: '湖南民族地区乡村治理有效简介',
        boxText: '湖南地形以山地丘陵为主，大陆性亚热带季风湿润气候。党的十八大以来,湖南深入践行习近平生态文明思想,牢记“守护好一江碧水”的殷殷嘱托,以前所未有的力度推进生态文明建设,全省生态环境发生了历史性、转折性、全局性变化。',
        images: [],
      },
      headTxt: '治理有效数据仓',
      mapBut: '湖南规划地图>>>',

      jiaoyuList: [],
      yiliaoList: [],
      // 卫生室建设
      weiShenShiChar: null,

      // 公共厕所建设
      ceSuoChar: null,


    }
  },
  mounted () {
    this.getDate()

    bus.$on('mapBus', (date) => {
      this.city_id = date.city_id
      this.getDate(date)
    })
  },
  methods: {
    getDate (date) {
      let newDate = "";
      if (date) {
        newDate = date.region;
      } else {
        newDate = "永州市";
      }

      console.log(this.city_id);
      var date = JSON.parse(localStorage.getItem("date"));
      date.forEach((item, index) => {
        if (item.region == newDate) {
          this.zlyxList = item;
        }
      });
      
      this.rightBox.images = []
      const introList = this.zlyxList.govern_intro.split('#')
      this.rightBox.boxText = introList[0]
      for (let i = 1; i < introList.length; i++)
      {
        this.rightBox.images.push(introList[i])
      }
      console.log(this.rightBox, '数据处理后');

      // 卫生室建设
      this.weiShenShiEcharts()

      // 公共厕所建设
      this.ceSuoEcharts()

      // var date = JSON.parse(localStorage.getItem("date"))
      // console.log(date[this.city_id].dlist);

      // 处理教育图片
      var kindergarten_imgList = []
      var school_imgList = []
      var educational_imgList = []
      kindergarten_imgList = this.zlyxList.dlist.map((item) => {
        return item.kindergarten_img
      })
      school_imgList = this.zlyxList.dlist.map((item) => {
        return item.school_img
      })
      educational_imgList = this.zlyxList.dlist.map((item) => {
        return item.educational_img
      })
      this.jiaoyuList = kindergarten_imgList.concat(school_imgList)
      this.jiaoyuList = this.jiaoyuList.concat(educational_imgList)

      for (var i = this.jiaoyuList.length - 1; i >= 0; i--)
      {
        if (this.jiaoyuList[i] == "" || this.jiaoyuList[i] == null)
        {
          this.jiaoyuList.splice(i, 1);
        }
      }
      if (this.jiaoyuList.length > 0)
      {
        this.jiaoyuList = this.jiaoyuList.join('、')
        this.jiaoyuList = this.jiaoyuList.split('、')
      }
      console.log(this.jiaoyuList, '教育图片');

      // 处理医疗卫生图片
      this.yiliaoList = this.zlyxList.dlist.map((item) => {
        return item.hospital_img
      })
      for (var i = this.yiliaoList.length - 1; i >= 0; i--)
      {
        if (this.yiliaoList[i] == "" || this.yiliaoList[i] == null)
        {
          this.yiliaoList.splice(i, 1);
        }
      }
      if (this.yiliaoList.length > 0)
      {
        this.yiliaoList = this.yiliaoList.join('、')
        this.yiliaoList = this.yiliaoList.split('、')
      }
      console.log(this.yiliaoList, '医疗卫生图片');

      // 处理大事记数据
      this.shiJiBox.shiJiList = this.zlyxList.dlist.map((item) => {
        return item.event_date + '  |  ' + item.event_influence + '  |  ' + item.event_name
      })
      console.log(this.shiJiBox.shiJiList, 'hhhhhhhh');
      for (var i = this.shiJiBox.shiJiList.length - 1; i >= 0; i--)
      {
        if (this.shiJiBox.shiJiList[i] == "  |    |  " || this.shiJiBox.shiJiList[i] == "null  |  null  |  null" || this.shiJiBox.shiJiList[i] == "无  |  无  |  无")
        {
          this.shiJiBox.shiJiList.splice(i, 1);
        }
      }
      console.log(this.shiJiBox.shiJiList);
    },

    // 卫生室建设
    weiShenShiEcharts () {
      this.weiShenShiChar = this.$echarts.init(document.getElementById("l_chart_weishenshi"));
      //窗口变动，echart重绘
      window.addEventListener("resize", () => {
        this.weiShenShiChar.resize()
      });
      var optoin = {
        title: {
          text: "卫生室建设",
          left: "0",
          top: '0',
          textStyle: {
            color: '#333',
            fontSize: this.$fontSize.fontSize(0.18)
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        xAxis: {
          axisLabel:
          {
            show: true,
            interval: 0,//使x轴上的文字显示完全,
            fontSize: this.$fontSize.fontSize(0.1),
            color: '#000',
            fontWeight: 900
          },
        },
        yAxis: {
          data: ['无分离', '三室分离', '五室分离', '总计'],
          axisLabel:
          {
            show: true,
            interval: 0,//使x轴上的文字显示完全,
            color: '#000',
            fontWeight: 900
          },
        },
        grid: {
          top: '30%',
          left: '30%',
          right: '8%',
          bottom: '3%',
          containLabel: true
        },
        series: [

          {
            type: 'bar',
            label: { //柱体上显示数值
              show: true,//开启显示
              position: 'right',
              formatter: '{c}',
            },
            data: [
              {
                value: this.zlyxList.d_Medical_without,
                itemStyle: {
                  color: '#5B8FF9'
                }
              },
              {
                value: this.zlyxList.d_Medical_three,
                itemStyle: {
                  color: '#E8684A'
                }
              },
              {
                value: this.zlyxList.d_Medical_five,
                itemStyle: {
                  color: '#9270CA'
                }
              },
              {
                value: this.zlyxList.d_Medical_without + this.zlyxList.d_Medical_three + this.zlyxList.d_Medical_five,
                itemStyle: {
                  color: '#269A99'
                }
              },
            ]
          }
        ]
      }
      this.weiShenShiChar.setOption(optoin)
    },

    // 公共厕所建设
    ceSuoEcharts () {
      this.ceSuoChar = this.$echarts.init(document.getElementById("l_chart_gongong"));
      //窗口变动，echart重绘
      window.addEventListener("resize", () => {
        this.ceSuoChar.resize()
      });
      var optoin = {

        title: {
          text: "公共厕所建设",
          left: "0",
          top: '0',
          textStyle: {
            color: '#333',
            fontSize: this.$fontSize.fontSize(0.18)
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          width: '50%',
          top: "30%",//图例组件离容器上侧的距离
          left: "40%",//图例组件离容器左侧的距离
          textStyle: {
            color: "#333"
          }
        },
        series: [
          {
            type: 'pie',
            avoidLabelOverlap: false,
            radius: '90%',
            center: ["75%", "50%"],
            itemStyle: {
              borderRadius: 3,
              borderColor: '#666',
            },
            label: {
              normal: {
                formatter: function (params) {
                  if (params.value > 0)
                  {
                    return params.value + '\n' + params.name;
                  } else
                  {
                    return '';
                  }
                },
                position: 'inner',
                rich: {
                  a: {
                    // color: '#ccc',
                    fontSize: 14,
                    lineHeight: 15
                  },
                  b: {                        //name 文字样式
                    fontSize: 14,
                    lineHeight: 15,
                    // color: '#666',
                  },
                  c: {                   //value 文字样式
                    fontSize: 14,
                    lineHeight: 15,
                    // color: '#666',
                    align: "center"
                  }
                }
              }
            },
            labelLine: {
              show: true
            },
            data: [
              {
                value: this.zlyxList.d_Medical_wchave,
                itemStyle: {
                  color: '#FFCC99'
                },
                name: '有'
              },
              {
                value: this.zlyxList.d_Medical_wcwithout,
                itemStyle: {
                  color: '#FF6666'
                },
                name: '无'
              }
            ]
          }
        ]
      }
      this.ceSuoChar.setOption(optoin)
    },
  }
}
</script>

<style lang="less" scoped>
.map_box {
  position: absolute;
  top: 7vh;
  left: 35%;
  width: 39%;
  height: 87vh;
}

.l_box {
  position: absolute;
  top: 16vh;
  left: 0;
  width: 34%;
  height: 58vh;
  margin: 1vh;

  .l_box_1 {
    height: 30vh;
    .l_box_1_1 {
      display: flex;
      .box {
        flex: 2;
        .box_title {
          padding: 1vh;
          margin: 0 1vh;
          border-bottom: 2px solid #333;
        }
        .box_txt {
          display: flex;
          .box_txt_1 {
            margin: 1vh 1vh 1vh 2vh;
            flex: 2;
            font-size: calc(100vw * 18 / 1920);
            li {
              padding: 1vh;
            }
          }
          .box_txt_2 {
            flex: 2;
            text-align: center;
            margin: auto;
            padding-bottom: 1%;
            margin-right: 5%;
            span {
              font-weight: 1000;
              font-size: calc(100vw * 80 / 1920);
              // color: #0099cc;
            }
          }
        }
      }
      .img {
        margin: 1vh;
        height: 18vh;
        flex: 2;
        background-color: #fff;
        div {
          width: 100%;
          height: 100%;
        }
      }
    }
    .l_box_1_2 {
      margin: 1vh 3vh;
      height: 3.2vh;
      display: flex;
      border-top: 2px solid #333;
      .box_1_2_txt {
        margin: auto;
      }
    }
  }

  .l_box_2 {
    margin-top: 1vh;
    height: 34vh;

    .box {
      display: flex;
      .img_box {
        flex: 2;
        .txt {
          padding: 2vh;
        }
        .img {
          margin: 1vh;
          height: 21vh;
          background-color: #fff;
          div {
            width: 100%;
            height: 100%;
          }
        }
      }
      .txt_box {
        flex: 3;
        .txt_box_1 {
          height: 14vh;
          position: relative;
          .box_1_t {
            position: absolute;
            left: 5%;
            top: 20%;
            text-align: center;
            span {
              font-size: calc(100vw * 50 / 1920);
              font-weight: 800;
            }
          }
          .chart1 {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>